module.exports = __webpack_public_path__ + "f45b22f7a34a9820aeadfe9594a6b041.svg";